import AjusteInventario from "./AjusteInventario";
export default AjusteInventario;